// "No items yet" placeholder. Plan 24. Covers the "Your calendar is
// currently clear", "No pending birth data requests", and "No
// testimonials to manage yet" patterns.

import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  cta?: ReactNode;
}

export const EmptyState = ({
  icon,
  title,
  description,
  cta,
  className,
  ...rest
}: EmptyStateProps) => (
  <div
    className={cn(
      'bg-stone-50 rounded-[2.5rem] p-12 md:p-16 text-center border-2 border-dashed border-stone-200',
      className
    )}
    {...rest}
  >
    {icon && (
      <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm text-stone-300">
        {icon}
      </div>
    )}
    <h3 className="text-2xl font-serif text-stone-500 italic mb-2">{title}</h3>
    {description && <p className="text-sm text-stone-400 mb-6">{description}</p>}
    {cta && <div className="mt-4 inline-block">{cta}</div>}
  </div>
);
